import React from "react";
export const MENUITEMS = [
  {
    title: "Inicio",
    icon: <i className="pe-7s-home pe-lg"></i>,
    path: `${process.env.PUBLIC_URL}/inicio`,
    type: "sub",
    permissions: ['ADMIN','DOCENT','DIRECTOR','SUBDIRECTOR','CAPTURISTA','SISTEMAS','TUTOR'],
    active: true,
    bookmark: true,
    children: [ 
      { title: "Inicio", type: "sub" },
      {
        title: "Inicio",
        type: "link",
        path: `${process.env.PUBLIC_URL}/inicio`,
        permissions: false,
      },
    ],
  },
  {
    title: "Herramientas",
    icon: <i className="pe-7s-portfolio pe-lg"></i>,
    type: "sub",
    permissions: ['ADMIN','DOCENT','DIRECTOR','SUBDIRECTOR','SISTEMAS','TUTOR'],
    path: `${process.env.PUBLIC_URL}/herramientas`,
    active: false,
    bookmark: true,
    children: [
      { title: "Herramientas", type: "sub" },
      {
        title: "Tareas",
        type: "link",
        path: `${process.env.PUBLIC_URL}/tareas`,
        permissions: false,
      },
      {
        title: "Ausencias ",
        type: "link",
        path: `${process.env.PUBLIC_URL}/ausencias`,
        permissions: false,
      },
      // {
      //   title: "Asistencias ",
      //   type: "link",
      //   path: `${process.env.PUBLIC_URL}/asistencias`,
      //   permissions: ['ADMIN','DOCENT','DIRECTOR','SUBDIRECTOR','SISTEMAS'],
      // },
    ],
  },
  {
    title: "Finanzas",
    icon: <i className="pe-7s-credit pe-lg"></i>,
    type: "sub",
    permissions: ['ADMIN','DIRECTOR','SUBDIRECTOR','SISTEMAS','TUTOR'],
    path: `${process.env.PUBLIC_URL}/herramientas`,
    active: false,
    bookmark: true,
    children: [
      { title: "Finanzas", type: "sub" },
      {
        title: "Colegiaturas",
        type: "link",
        path: `${process.env.PUBLIC_URL}/colegiaturas`,
        permissions: ['ADMIN','DIRECTOR','SUBDIRECTOR','SISTEMAS','CAPTURISTA','TUTOR'],
      },
      {
        title: "Inscripciones",
        type: "link",
        path: `${process.env.PUBLIC_URL}/inscripciones`,
        permissions: ['ADMIN','DIRECTOR','SUBDIRECTOR','SISTEMAS','CAPTURISTA','TUTOR'],
      },
    ],
  },
  {
    title: "Configuración",
    icon: <i className="pe-7s-settings pe-lg"></i>,
    type: "sub",
    permissions: ['ADMIN','DOCENT','DIRECTOR','SUBDIRECTOR','CAPTURISTA','SISTEMAS','TUTOR'],
    path: `${process.env.PUBLIC_URL}/configuracion`,
    active: false,
    children: [
      { title: "Configuración", type: "sub" },
      {
        title: "Notificaciones",
        type: "link",
        path: `${process.env.PUBLIC_URL}/configuracion/notificaciones`,
        permissions: false,
      },
    ],
  },
  {
    title: "Administrar",
    icon: <i className="pe-7s-config"></i>,
    type: "sub",
    permissions: ['ADMIN','DIRECTOR','SUBDIRECTOR','CAPTURISTA','SISTEMAS'],
    path: `${process.env.PUBLIC_URL}/administrar`,
    active: true,
    children: [
      { title: "Form Controls", type: "sub" },
      {
        title: "Alumnos",
        type: "link",
        path: `${process.env.PUBLIC_URL}/alumnos`,
        permissions: ['ADMIN','DIRECTOR','SUBDIRECTOR','SISTEMAS','CAPTURISTA'],
      },
      {
        title: "Padres",
        type: "link",
        path: `${process.env.PUBLIC_URL}/padres`,
        permissions: ['ADMIN','DIRECTOR','SISTEMAS'],
      },
      {
        title: "Maestros",
        type: "link",
        path: `${process.env.PUBLIC_URL}/maestros`,
        permissions: ['ADMIN','DIRECTOR','SUBDIRECTOR','SISTEMAS'],
      },
      {
        title: "Personal",
        type: "link",
        path: `${process.env.PUBLIC_URL}/personal`,
        permissions: ['ADMIN','DIRECTOR','SISTEMAS'],
      },
      {
        title: "Grados",
        type: "link",
        path: `${process.env.PUBLIC_URL}/grados`,
        permissions: ['ADMIN','DIRECTOR','SUBDIRECTOR','SISTEMAS'],
      },
    ],
  },
];
